import { useApp } from '../../context/AppContext';

const ICONS = {
  success: 'fa-solid fa-circle-check',
  error: 'fa-solid fa-circle-exclamation',
  info: 'fa-solid fa-circle-info',
};

export default function Toast() {
  const { toast } = useApp();
  const type = toast.type || 'info';

  return (
    <div
      className={`toast toast-${type} ${toast.show ? 'show' : ''}`}
      role="status"
      aria-live={type === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true"
      style={{ maxWidth: '380px' }}
    >
      <i className={ICONS[type] || ICONS.info} aria-hidden="true" style={{ flexShrink: 0 }} />
      <span>{toast.msg}</span>
    </div>
  );
}
